import { axiosInstance } from './index';
import { PartnerReviewResponse, PartnerReviewRequestType } from '../../types/partnerReport';
import { PartnerReportedDetailsRequestType, ReportedDetailsRequestType } from '../../types/report';

export const partnerReportService = {
    async getPartnerReviewsList(params: PartnerReviewRequestType) {
        const { data } = await axiosInstance.get('/PartnerReviewReply/GetReportedPartnerReviewsPaginatedList', {
            params,
        });
        return data;
    },

    async getPartnerRepliesList(params: PartnerReviewRequestType) {
        const { data } = await axiosInstance.get('/PartnerReviewReply/GetReportedPartnerReplyPaginatedList', {
            params,
        });
        return data;
    },

    async getPartnerReportedDetailsList(params: { partnerReviewId: string; partnerReplyId: string }) {
        const { data } = await axiosInstance.get(`PartnerReviewReply/GetPartnerReviewOrReply`, { params });
        return data as any;
    },

    async setPartnerReviewReportedAction(params: any) {
        const { data } = await axiosInstance.patch(`PartnerReviewReply/UpdatePartnerReviewReportStatus`, params);
        return data as any;
    },

    async setPartnerReplyReportedAction(params: any) {
        const { data } = await axiosInstance.patch(`PartnerReviewReply/UpdatePartnerReplyReportStatus`, params);
        return data as any;
    },
};
